import css from 'styled-jsx/css'
import { colors } from '../../styles'

export default css`
  .no-player {
    aspect-ratio: 16/9;
    object-fit: fill;
    width: 100%;
    display: flex;
    justify-content: center;
    align-items: center;
    background-color: ${colors.black};
    z-index: 1;
    margin-bottom: 15px;
    position: relative;
  }

  .sub-menu {
    padding: 16px;
  }
  main.Live {
    padding-top: 12px;
  }
  .live-player-wrapper {
    border-radius: 16px;
    overflow: hidden;
    flex-grow: 1;
  }
  :global(.Overlay) {
    position: relative !important;
  }
  :global(.ot-floating-button) {
    display: none !important;
  }
  ul {
    margin: 0;
    padding: 0px 0px 0px 0px;
    list-style: none;
  }
  .featureTab-Wrapper {
    top: 60%;
    position: relative;
    width: 100%;
    z-index: 9;
    padding-top: 8px;
  }

  p {
    color: ${colors.primaryText};
    font-display: optional;
  }
  .featured {
    margin-top: 24px;
  }

  .featured-tab-item {
    display: block;
  }
  .recommended {
    margin-left: 0px;
    margin-right: 0px;
    margin-top: 0px;
  }
  .await-check-div {
    padding-top: 23.125%;
    padding-bottom: 23.125%;
    object-fit: fill;
    width: 100%;
    display: flex;
    justify-content: center;
    align-items: center;
    background-color: ${colors.black};
    z-index: 1;
  }

  .banner-wrapper {
    display: flex;
    flex-direction: column;
    align-items: center;
    padding-bottom: 12px;
  }

  .banner-image {
    width: 100%;
  }

  @media (min-width: 768px) {
    .Live {
      min-width: 80%;
    }
    .sub-menu {
      padding: 8px 0 0;
    }

    .now-next {
      height: 300px;
    }
    .featured {
      display: flex;
      flex-direction: row;
      justify-content: space-between;
      margin-left: 16px;
      margin-right: 16px;
    }
    .mpu-container {
      margin-left: 24px;
    }
    .featureTab-Wrapper {
      position: relative;
      top: unset;
      padding-top: 0px;
    }
    .featured-videos {
      width: ${(7 / 12) * 100}%;
      padding-right: 16px;
    }
    .featured-sidebar {
      width: ${(5 / 12) * 100}%;
      align-items: flex-end;
      max-width: 340px;
    }
    .featured-tabs-content {
      display: flex;
      flex-grow: 1;
      flex-wrap: wrap;
      justify-content: space-between;
    }
    .tab-loader {
      display: flex;
      align-items: center;
      justify-content: center;
      width: 100%;
    }
    .recommended h2 {
      margin-bottom: 0.5em;
    }
  }

  @media (max-width: 1199px) {
    .sub-menus {
      margin-bottom: 12px;
    }
    .live-content-row {
      display: flex;
      flex-direction: column;
      width: 100%;
      gap: 12px;
    }
    .live-content-column-large {
      width: 100%;
      display: flex;
      flex-direction: column;
      position: relative;
    }
    .live-content-column-small {
      width: 100%;
      display: flex;
      flex-direction: row;
    }
  }

  @media (min-width: 1200px) {
    .live-content-row {
      display: flex;
      flex-direction: row;
      width: 100%;
      gap: 12px;
    }
    .sub-menus.mobile {
      display: block;
      padding-bottom: 16px;
    }
    .live-content-column-large {
      width: 100%;
      display: flex;
      flex: 2 0 0;
      flex-direction: column;
      position: relative;
      max-width: calc(66% - 6px);
    }
    .live-content-column-large.larger {
      max-width: calc(100% - 6px) !important;
      margin: 0px auto;
    }
    .live-content-column-small {
      min-width: 408px;
      gap: 12px;
      display: flex;
      flex-direction: column;
      flex: 1 0 0;
      max-width: calc(33% - 6px);
    }
  }
`
